import React, { FunctionComponent, useEffect, useRef, useState } from 'react'
import classNames from 'classnames'
import { QuickKeyKey } from '../../../quick-keys/qk-types'
import { QuickKeyNodeType } from '../../../quick-keys/qk.constants'
import { useImageURLForQuickKey } from '../useImageURLForQuickKey'

interface QKKeyProps {
  quickKey: QuickKeyKey
  setFocus: (node: QuickKeyKey) => void
  isFocussed?: boolean
  onClick: (qk: QuickKeyKey) => void
}

export const QKKey: FunctionComponent<QKKeyProps> = ({
  quickKey,
  isFocussed,
  setFocus,
  onClick,
}) => {
  const imageURL = useImageURLForQuickKey(quickKey)

  const [hover, setHover] = useState(false)

  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (containerRef.current && isFocussed) {
      containerRef.current.focus()
    }
  }, [isFocussed])

  return (
    <div
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      onMouseDown={() => setFocus(quickKey)}
      onClick={() => onClick(quickKey)}
      ref={containerRef}
      // eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
      tabIndex={isFocussed ? 0 : undefined}
      className={classNames(
        'vd-quick-key',
        `vd-quick-key--${quickKey.viewData.color}`,
        `vd-quick-key--${QuickKeyNodeType.QUICK_KEY}`,
        { 'vd-quick-key--hover': hover }
      )}
    >
      <div
        className={classNames('vd-quick-key-inner', {
          'vd-quick-key-inner--with-image': imageURL,
        })}
        data-product-id={quickKey.node.product_id}
      >
        {imageURL && (
          <div
            className="vd-quick-key-image"
            style={{ backgroundImage: `url(${imageURL})` }}
          />
        )}
        <span className="vd-quick-key-label">{quickKey.viewData.label}</span>
      </div>
    </div>
  )
}
